<template>
    <div id="got-award" v-if = "show">
        <div class="mask" @touchmove="touchMove">
            <div :class="['content',code?'code':'']">
                <div class="title">
                    <p class="of">{{name}}</p>
                    <p class="of">有效期{{coupon.startTime | time}} - {{coupon.endTime | time}}</p>
                </div>
                <div class="img" :style="{backgroundImage:`url(${img})`}"></div>
                <div v-if="awardType === 1">
                    <router-link class="link" v-if="!code" tag="div" :to="{path:'/info',query:{awardId:awardId,from:'turnplate'}}">
                        <div class="get-code" :data-awardid="awardId">获取兑奖码>></div>
                    </router-link>
                    <router-link class="link" v-else tag="div" :to="{path:'/awards'}">
                        <div class="show-code">兑奖码:{{code}}</div>
                    </router-link>
                </div>
                <div v-else-if="awardType === 2">
                    <div class="link">
                        <a :href="couponLink" class="go-coupon">立即使用</a>
                    </div>
                </div>
                <i class="cancel" @click="cancel"></i>
            </div>
        </div>
    </div>
</template>
<style>

</style>
<script type="text/ecmascript-6">
    import '../css/getaward-new.less';
    import config from '../../../config/api.config';
    export default{
        data(){
            return{
                show:false,
                name:'',
                time:'',
                img:'',
                code:'',
                awardId:-1,
                awardType:-1,//1实物 2 优惠券
                couponLink:'#',
                coupon: {}
            }
        },
        components:{
        },
        methods:{
            cancel(){
                this.show = false;
            },
            touchMove(e){
                e.preventDefault();
                e.stopPropagation();
            }
        },
        mounted(){
            let self = this;
            eventBus.$on('show',function (data) {
                self.show = true;
                self.img = data.pic;
                self.code = data.winerCode;
                self.awardId = data.id;
                self.awardType = data.awardType;
                self.coupon = JSON.parse(data.features).coupon;
                self.name = '满'+parseFloat(self.coupon.full/100)+'减'+parseFloat(self.coupon.reduce/100)+'优惠券';

                if(data.awardType === 2){//优惠券
                    if(self.coupon.type == 0) {
                        // self.couponLink = config.host+'/m/weidian-buyer/shop/index.html?shopId='+self.coupon.shopId;
                        self.couponLink = "https://weidian.com/?userid=" + self.coupon.shopId;
                    } else {
                        self.couponLink = config.host+'/m/mycoupon/list.html?shop_id='+self.coupon.shopId+'&coupon_id='+self.coupon.couponId;
                    }
                }
            });
            eventBus.$on('hide',function (data) {
                self.show = false;
            });
        }
    }
</script>



/** WEBPACK FOOTER **
 ** getaward-new.vue?e3488216
 **/